// This is generated.  Alter it in blockGroups/formElements/types/Coordinates.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      required,
      firstCoordinateLabel,
      secondCoordinateLabel,
    } = hNode;

    const subDataDictionary = {};

    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
      required,
      context,
    );

    // Helper to wrap a schema as optional if needed
    // Type.Optional creates JSON Schema optional property (not required)
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // Coordinates as strings; use labels as titles and preserve editability in custom extensions
    const firstCoordinateSchema = maybeOptional(
      Type.String({
        title: firstCoordinateLabel,
        'x-propertyName': 'firstCoordinate',
        ...schemaOptions,
      }),
    );

    const secondCoordinateSchema = maybeOptional(
      Type.String({
        title: secondCoordinateLabel,
        'x-propertyName': 'secondCoordinate',
        ...schemaOptions,
      }),
    );

    // The inner object for the dynamic propertyName
    const innerObjectSchema = Type.Object(
      {
        firstCoordinate: firstCoordinateSchema,
        secondCoordinate: secondCoordinateSchema,
      },
      {
        title: title,
        // Preserve metadata using custom extensions
        'x-id': id,
        'x-dataType': 'object',
        'x-propertyName': propertyName,
        ...schemaOptions,
        // additionalProperties: true allows extending this object with extra properties
        // This enables other blocks to add metadata without breaking validation
        additionalProperties: true,
      },
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: maybeOptional(innerObjectSchema),
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'Coordinates',
  module.exports,
);
